"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var subjectMatchesTitle = function (title) { return function (s) {
    return s.name.toLowerCase() === title.toLowerCase();
}; };
exports.getSubjectByTitle = function (subjects, title) {
    var subject = subjects.find(subjectMatchesTitle(title));
    if (!subject) {
        throw new Error("could not find: " + title);
    }
    return subject;
};
//# sourceMappingURL=getSubjectByTitle.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/subjects_data/getSubjectByTitle.js
// module id = 204
// module chunks = 22